import React from 'react';

type Props = {
    title: string;
    subTitle: string;
};
function WarningModalContent({ title, subTitle }: Props) {
    return (
        <>
            {title}
            <div style={{ marginTop: '24px' }} data-testid='sub-title'>
                {subTitle}
            </div>
        </>
    );
}

export default React.memo(WarningModalContent);
